import { makeStyles } from '@mui/styles/'

const styles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1.5rem',
    width: '100%',
    maxWidth: '100vw',
    padding: '0 1rem',
  },

  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 'calc(100vh - 150px)',
  },

  titleBar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
  },

  sent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '50%',
  },

  formBox: {
    width: 500,
    maxWidth: '80%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 1rem',
    gap: '1.5rem',
    alignItems: 'center',
    '& button': {
      marginTop: '1rem',
    },
  },

  divider: {
    width: '100%',
  },

  link: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: '500',
    '&:hover': {
      textDecoration: 'underline',
    },
    fontSize: '1.5rem',
    marginBottom: 15,
  },
}))

export default styles
